import * as loginActions from '../login/actions';
import * as branchesActions from './actions';
import * as barActions from '../bars/actions';
import {Record} from 'immutable';
import {List, fromJS} from 'immutable';

const State = Record({
    branches: List(),
    branch: null,
    noBranches: false
});

const BRANCHES = 'branches';
const BRANCH = 'branch';
const NO_BRANCHES = 'noBranches';

const branchReducer = (state = new State(), action) => {

    switch (action.type) {
        case branchesActions.FETCH_BRANCHES_SUCCESS: {
            const branches = fromJS(action.payload.data);
            if (branches.size > 0) {
                return state.set(BRANCHES, branches);
            }
            return state.set(NO_BRANCHES, true);
        }
        case loginActions.API_LOGOUT:
        case branchesActions.FETCH_BRANCHES_START: {
            return state
                .set(NO_BRANCHES, false)
                .set(BRANCHES, List());
        }
        case barActions.CHOOSE_BAR: {
            return state
                .set(BRANCHES, List())
                .set(BRANCH, action.payload.branch);
        }
    }

    return state;
};

export default branchReducer;



// WEBPACK FOOTER //
// ./src/common/branches/reducer.js